import React from 'react';

import { Figure } from '../../Menu/SearchableMenu';
import { ItemWrapper } from '../../Menu/Menu';

interface ISelectedAndRecentFieldProps {
  searchValue?: string;
  multipleSelections?: any;
  ListLabel?: any;
  Item?: any;
  highlightedIndex?: number;
  entityColorScale?: any;
  isDisplayedWithFlag?: boolean;
  isSmallScreen?: boolean;
  itemToString: (item: any) => string | null;
  getItemProps: any;
  recentItems?: any;
  selectedItems?: any;
  selectedItem?: any;
  showAllItems?: boolean;
  lengthOfAllItems: number;
  textToSelect?: string;
}

const SelectedAndRecentField: React.FC<ISelectedAndRecentFieldProps> = ({
  searchValue,
  multipleSelections,
  ListLabel,
  Item,
  highlightedIndex,
  entityColorScale,
  isDisplayedWithFlag,
  isSmallScreen,
  itemToString,
  getItemProps,
  recentItems,
  selectedItems,
  selectedItem,
  lengthOfAllItems,
  showAllItems,
  textToSelect,
}) => {
  const itemsLength = showAllItems
    ? lengthOfAllItems
    : multipleSelections.length + recentItems?.length;
  return (
    <>
      {!searchValue && !!multipleSelections?.length && (
        <>
          <li>
            <Figure data-menu-figure={true}>
              {ListLabel && (
                <figcaption>
                  <ListLabel>SELECTED</ListLabel>
                </figcaption>
              )}
            </Figure>
          </li>

          {multipleSelections.map((item: any, index: number) => (
            <ItemWrapper
              key={itemToString(item)}
              {...getItemProps({
                'data-menu-list-item': true,
                key: itemToString(item),
                item: item,
                isActive: true,
              })}
            >
              <Item
                item={item}
                index={index}
                isHovered={
                  highlightedIndex ===
                  itemsLength -
                    multipleSelections.length -
                    recentItems?.length +
                    index
                }
                isActive={
                  itemToString(selectedItem) === itemToString(item) ||
                  (selectedItems && selectedItems.includes(itemToString(item)))
                }
                entityColorScale={entityColorScale}
                isDisplayedWithFlag={isDisplayedWithFlag}
                isSmallScreen={isSmallScreen}
              />
            </ItemWrapper>
          ))}
        </>
      )}
      {!!recentItems?.length && (
        <li>
          <Figure data-menu-figure={true}>
            {ListLabel && (
              <figcaption>
                <ListLabel>RECENT</ListLabel>
              </figcaption>
            )}
          </Figure>
        </li>
      )}
      {!!recentItems?.length &&
        recentItems.map((item: any, index: number) => (
          <ItemWrapper
            key={itemToString(item)}
            {...getItemProps({
              'data-menu-list-item': true,
              key: itemToString(item),
              item: item,
              isActive: false,
            })}
          >
            <Item
              item={item}
              index={index}
              isHovered={
                highlightedIndex === itemsLength - recentItems.length + index
              }
              isActive={false}
              entityColorScale={entityColorScale}
              isDisplayedWithFlag={isDisplayedWithFlag}
              isSmallScreen={isSmallScreen}
            />
          </ItemWrapper>
        ))}

      {showAllItems && (
        <li>
          <Figure data-menu-figure={true}>
            {ListLabel && (
              <figcaption>
                <ListLabel>
                  SELECT{' '}
                  {textToSelect ? textToSelect.toUpperCase() : 'GENRE(S)'}
                </ListLabel>
              </figcaption>
            )}
          </Figure>
        </li>
      )}
    </>
  );
};

export default SelectedAndRecentField;
